import styled from "styled-components";

import { FlexRow } from "@similarweb/ui-components";

export const ContextMenuContainer = styled(FlexRow)`
    position: relative;
    width: 4.2%;
    margin-left: auto;
`;

export const Icon = styled(FlexRow)`
    align-items: center;
    justify-content: center;
`;

export const InnerItem = styled(FlexRow)`
    gap: 8px;
`;
